import React, { useState } from "react";
import Modal from "react-modal";
import "./PaymentMethodPopup.css";

Modal.setAppElement("#root");

const PaymentMethodPopup = ({
  isOpen,
  onClose,
  onSelectWallet,
  onSelectDirect,
  walletBalance = 0,
}) => {
  const [showWalletBenefits, setShowWalletBenefits] = useState(false);

  const handleWalletClick = () => {
    setShowWalletBenefits(true);
  };

  const handleContinueToWallet = () => {
    setShowWalletBenefits(false);
    onSelectWallet();
  };

  const handleDirectClick = () => {
    onSelectDirect();
  };

  const handleClose = () => {
    setShowWalletBenefits(false);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      className="payment-method-modal"
      overlayClassName="payment-method-overlay"
      closeTimeoutMS={300}
    >
      {!showWalletBenefits ? (
        <div className="payment-method-content">
          <div className="payment-method-header">
            <div className="payment-method-icon">
              <i className="fas fa-credit-card"></i>
            </div>
            <h3>Choose Payment Method</h3>
            <p>How would you like to proceed with your payment?</p>
          </div>

          <div className="payment-options">
            <button
              className="payment-option wallet-option"
              onClick={handleWalletClick}
            >
              <div className="option-icon">
                <i className="fas fa-wallet"></i>
              </div>
              <div className="option-details">
                <h4>Pay with Wallet</h4>
                <p>Use your wallet balance</p>
                <span className="balance-info">
                  Balance: {walletBalance} Coins
                </span>
              </div>
              <i className="fas fa-chevron-right"></i>
            </button>

            <button
              className="payment-option direct-option"
              onClick={handleDirectClick}
            >
              <div className="option-icon">
                <i className="fas fa-university"></i>
              </div>
              <div className="option-details">
                <h4>Direct Payment</h4>
                <p>Pay via UPI/Card/NetBanking</p>
              </div>
              <i className="fas fa-chevron-right"></i>
            </button>
          </div>

          <button className="cancel-btn" onClick={handleClose}>
            Cancel
          </button>
        </div>
      ) : (
        <div className="wallet-benefits-content">
          <div className="benefits-icon">
            <i className="fas fa-gift"></i>
          </div>
          <h3>Wallet Payment Benefits</h3>

          <div className="benefits-list">
            <div className="benefit-item">
              <i className="fas fa-ticket-alt"></i>
              <span>Eligible for Lucky Draw entries</span>
            </div>
            <div className="benefit-item">
              <i className="fas fa-percentage"></i>
              <span>Additional discounts on future purchases</span>
            </div>
            <div className="benefit-item">
              <i className="fas fa-bolt"></i>
              <span>Faster checkout experience</span>
            </div>
          </div>

          <div className="wallet-action-buttons">
            <button
              className="back-btn"
              onClick={() => setShowWalletBenefits(false)}
            >
              <i className="fas fa-arrow-left"></i> Back
            </button>
            <button
              className="continue-wallet-btn"
              onClick={handleContinueToWallet}
            >
              Go to Wallet <i className="fas fa-arrow-right"></i>
            </button>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default PaymentMethodPopup;
